import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import company from "./company"
import person from "./person"
import store from "./store"
import remark from "./remark"
import resources from "./resources"
import intermediary from "./intermediary"
import nrent from "./nrent"
import nstock from "./nstock"

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    beforeEnter(to, from, next) {
      document.title = '聊城房屋交易租赁平台';
      next()
    },
  },
  {
    path: '/logIn',
    name: 'logIn',
    component: () => import( '../views/LogIn/index.vue'),
    beforeEnter(to, from, next) {
      document.title = '聊城房屋交易租赁平台';
      next()
    },
  },
  {
    path: '/organRegister',
    name: 'organRegister',
    component: () => import( '../views/LogIn/organ.vue'),
    beforeEnter(to, from, next) {
      document.title = '聊城房屋交易租赁平台';
      next()
    },
  },
  {
    path: '/personalRegister',
    name: 'personalRegister',
    component: () => import( '../views/LogIn/personal.vue'),
    beforeEnter(to, from, next) {
      document.title = '聊城房屋交易租赁平台';
      next()
    },
  },
  
  {
    path: '/mCompanyDetail',
    component: () => import( '../views/Company/MobileDetail.vue'),
    beforeEnter(to, from, next) {
      document.title = '聊城房屋交易租赁平台';
      next()
    },
  },
  {
    path: '/mPersonDetail',
    component: () => import( '../views/Person/MobileDetail.vue'),
    beforeEnter(to, from, next) {
      document.title = '聊城房屋交易租赁平台';
      next()
    },
  },
  {
    path: '/credit/list',
    component: () => import( '../views/Credit/List.vue'),
    beforeEnter(to, from, next) {
      document.title = '聊城房屋交易租赁平台';
      next()
    },
  },
  {
    path: '/credit/personList',
    component: () => import( '../views/Credit/PersonList.vue'),
    beforeEnter(to, from, next) {
      document.title = '聊城房屋交易租赁平台';
      next()
    },
  },
  ...company,
  ...person,
  ...store,
  ...remark,
  ...resources,
  ...intermediary,
  ...nrent,
  ...nstock,
]

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
